import { preloadDraft } from '@confluence/fabric-providers/entry-points/preloadDraft.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';

export async function preloadEditPageRoutePostSSR(match: RouteMatch, _url: string): Promise<void> {
	const { contentId, draftShareId } = match.params;

	await preloadDraft(contentId, draftShareId);
}
